var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.11683 18.7L20.1127 11.8433C20.8552 11.5225 20.8552 10.4775 20.1127 10.1567L4.11683 3.30001C3.51183 3.03417 2.84266 3.48334 2.84266 4.13417L2.8335 8.36C2.8335 8.81834 3.17266 9.2125 3.631 9.2675L16.5835 11L3.631 12.7233C3.17266 12.7875 2.8335 13.1817 2.8335 13.64L2.84266 17.8658C2.84266 18.5167 3.51183 18.9658 4.11683 18.7Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/SendIcon.a32ed68b0cf4f1d5d2c1465bc6a39402.svg";
export { ForwardRef as ReactComponent };